import React, { FC } from 'react'
import { cn } from '../../../shared/utils'

import styles from '../Story.module.scss'

type TStorySectionProps = {}
export const StorySection: FC<TStorySectionProps> = (props) => {
  return (
    <div className={cn(styles.section)}>
      {props.children}
    </div>
  )
}
